export const Countries_List = [
  {
    code: "AB",
    name: "Abkhazia",
    three_letter_code: "ABK",
    iso_numeric: 0,
  },
  {
    code: "AL",
    name: "Albania",
    three_letter_code: "ALB",
    iso_numeric: 8,
  },
  {
    code: "DZ",
    name: "Algeria",
    three_letter_code: "DZA",
    iso_numeric: 12,
  },
  {
    code: "AS",
    name: "American Samoa",
    three_letter_code: "ASM",
    iso_numeric: 16,
  },
  {
    code: "AD",
    name: "Andorra",
    three_letter_code: "AND",
    iso_numeric: 20,
  },
  {
    code: "AO",
    name: "Angola",
    three_letter_code: "AGO",
    iso_numeric: 24,
  },
  {
    code: "AI",
    name: "Anguilla",
    three_letter_code: "AIA",
    iso_numeric: 660,
  },
  {
    code: "AQ",
    name: "Antarctica",
    three_letter_code: "ATA",
    iso_numeric: 10,
  },
  {
    code: "AG",
    name: "Antigua and Barbuda",
    three_letter_code: "ATG",
    iso_numeric: 28,
  },
  {
    code: "AR",
    name: "Argentina",
    three_letter_code: "ARG",
    iso_numeric: 32,
  },
  {
    code: "AM",
    name: "Armenia",
    three_letter_code: "ARM",
    iso_numeric: 51,
  },
  {
    code: "AW",
    name: "Aruba",
    three_letter_code: "ABW",
    iso_numeric: 533,
  },
  {
    code: "AU",
    name: "Australia",
    three_letter_code: "AUS",
    iso_numeric: 36,
  },
  {
    code: "AT",
    name: "Austria",
    three_letter_code: "AUT",
    iso_numeric: 40,
  },
  {
    code: "AZ",
    name: "Azerbaijan",
    three_letter_code: "AZE",
    iso_numeric: 31,
  },
  {
    code: "BS",
    name: "Bahamas",
    three_letter_code: "BHS",
    iso_numeric: 44,
  },
  {
    code: "BH",
    name: "Bahrain",
    three_letter_code: "BHR",
    iso_numeric: 48,
  },
  {
    code: "BD",
    name: "Bangladesh",
    three_letter_code: "BGD",
    iso_numeric: 50,
  },
  {
    code: "BB",
    name: "Barbados",
    three_letter_code: "BRB",
    iso_numeric: 52,
  },
  {
    code: "BY",
    name: "Belarus",
    three_letter_code: "BLR",
    iso_numeric: 112,
  },
  {
    code: "BE",
    name: "Belgium",
    three_letter_code: "BEL",
    iso_numeric: 56,
  },
  {
    code: "BZ",
    name: "Belize",
    three_letter_code: "BLZ",
    iso_numeric: 84,
  },
  {
    code: "BJ",
    name: "Benin",
    three_letter_code: "BEN",
    iso_numeric: 204,
  },
  {
    code: "BM",
    name: "Bermuda",
    three_letter_code: "BMU",
    iso_numeric: 60,
  },
  {
    code: "BT",
    name: "Bhutan",
    three_letter_code: "BTN",
    iso_numeric: 64,
  },
  {
    code: "BO",
    name: "Bolivia",
    three_letter_code: "BOL",
    iso_numeric: 68,
  },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    three_letter_code: "BIH",
    iso_numeric: 70,
  },
  {
    code: "BW",
    name: "Botswana",
    three_letter_code: "BWA",
    iso_numeric: 72,
  },
  {
    code: "BR",
    name: "Brazil",
    three_letter_code: "BRA",
    iso_numeric: 76,
  },
  {
    code: "IO",
    name: "British Indian Ocean Territory",
    three_letter_code: "IOT",
    iso_numeric: 86,
  },
  {
    code: "VG",
    name: "British Virgin Islands",
    three_letter_code: "VGB",
    iso_numeric: 92,
  },
  {
    code: "BN",
    name: "Brunei",
    three_letter_code: "BRN",
    iso_numeric: 96,
  },
  {
    code: "BG",
    name: "Bulgaria",
    three_letter_code: "BGR",
    iso_numeric: 100,
  },
  {
    code: "BF",
    name: "Burkina Faso",
    three_letter_code: "BFA",
    iso_numeric: 854,
  },
  {
    code: "KH",
    name: "Cambodia",
    three_letter_code: "KHM",
    iso_numeric: 116,
  },
  {
    code: "CM",
    name: "Cameroon",
    three_letter_code: "CMR",
    iso_numeric: 120,
  },
  {
    code: "CA",
    name: "Canada",
    three_letter_code: "CAN",
    iso_numeric: 124,
  },
  {
    code: "CV",
    name: "Cape Verde",
    three_letter_code: "CPV",
    iso_numeric: 132,
  },
  {
    code: "KY",
    name: "Cayman Islands",
    three_letter_code: "CYM",
    iso_numeric: 136,
  },
  {
    code: "TD",
    name: "Chad",
    three_letter_code: "TCD",
    iso_numeric: 148,
  },
  {
    code: "CL",
    name: "Chile",
    three_letter_code: "CHL",
    iso_numeric: 152,
  },
  {
    code: "CN",
    name: "China",
    three_letter_code: "CHN",
    iso_numeric: 156,
  },
  {
    code: "CX",
    name: "Christmas Island",
    three_letter_code: "CXR",
    iso_numeric: 162,
  },
  {
    code: "CC",
    name: "Cocos (Keeling) Islands",
    three_letter_code: "CCK",
    iso_numeric: 166,
  },
  {
    code: "CO",
    name: "Colombia",
    three_letter_code: "COL",
    iso_numeric: 170,
  },
  {
    code: "CG",
    name: "Congo",
    three_letter_code: "COG",
    iso_numeric: 178,
  },
  {
    code: "CK",
    name: "Cook Islands",
    three_letter_code: "COK",
    iso_numeric: 184,
  },
  {
    code: "CR",
    name: "Costa Rica",
    three_letter_code: "CRI",
    iso_numeric: 188,
  },
  {
    code: "CI",
    name: "Côte d’Ivoire",
    three_letter_code: "CIV",
    iso_numeric: 384,
  },
  {
    code: "HR",
    name: "Croatia",
    three_letter_code: "HRV",
    iso_numeric: 191,
  },
  {
    code: "CW",
    name: "Curacao",
    three_letter_code: "CUW",
    iso_numeric: 531,
  },
  {
    code: "CY",
    name: "Cyprus",
    three_letter_code: "CYP",
    iso_numeric: 196,
  },
  {
    code: "CZ",
    name: "Czech Republic",
    three_letter_code: "CZE",
    iso_numeric: 203,
  },
  {
    code: "DK",
    name: "Denmark",
    three_letter_code: "DNK",
    iso_numeric: 208,
  },
  {
    code: "DJ",
    name: "Djibouti",
    three_letter_code: "DJI",
    iso_numeric: 262,
  },
  {
    code: "DM",
    name: "Dominica",
    three_letter_code: "DMA",
    iso_numeric: 212,
  },
  {
    code: "DO",
    name: "Dominican Republic",
    three_letter_code: "DOM",
    iso_numeric: 214,
  },
  {
    code: "EC",
    name: "Ecuador",
    three_letter_code: "ECU",
    iso_numeric: 218,
  },
  {
    code: "EG",
    name: "Egypt",
    three_letter_code: "EGY",
    iso_numeric: 818,
  },
  {
    code: "SV",
    name: "El Salvador",
    three_letter_code: "SLV",
    iso_numeric: 222,
  },
  {
    code: "GQ",
    name: "Equatorial Guinea",
    three_letter_code: "GNQ",
    iso_numeric: 226,
  },
  {
    code: "EE",
    name: "Estonia",
    three_letter_code: "EST",
    iso_numeric: 233,
  },
  {
    code: "ET",
    name: "Ethiopia",
    three_letter_code: "ETH",
    iso_numeric: 231,
  },
  {
    code: "FK",
    name: "Falkland Islands (Islas Malvinas)",
    three_letter_code: "FLK",
    iso_numeric: 238,
  },
  {
    code: "FO",
    name: "Faroe Islands",
    three_letter_code: "FRO",
    iso_numeric: 234,
  },
  {
    code: "FJ",
    name: "Fiji",
    three_letter_code: "FJI",
    iso_numeric: 242,
  },
  {
    code: "FI",
    name: "Finland",
    three_letter_code: "FIN",
    iso_numeric: 246,
  },
  {
    code: "FR",
    name: "France",
    three_letter_code: "FRA",
    iso_numeric: 250,
  },
  {
    code: "GF",
    name: "French Guiana",
    three_letter_code: "GUF",
    iso_numeric: 254,
  },
  {
    code: "PF",
    name: "French Polynesia",
    three_letter_code: "PYF",
    iso_numeric: 258,
  },
  {
    code: "GA",
    name: "Gabon",
    three_letter_code: "GAB",
    iso_numeric: 266,
  },
  {
    code: "GM",
    name: "Gambia",
    three_letter_code: "GMB",
    iso_numeric: 270,
  },
  {
    code: "GE",
    name: "Georgia",
    three_letter_code: "GEO",
    iso_numeric: 268,
  },
  {
    code: "DE",
    name: "Germany",
    three_letter_code: "DEU",
    iso_numeric: 276,
  },
  {
    code: "GH",
    name: "Ghana",
    three_letter_code: "GHA",
    iso_numeric: 288,
  },
  {
    code: "GI",
    name: "Gibraltar",
    three_letter_code: "GIB",
    iso_numeric: 292,
  },
  {
    code: "GR",
    name: "Greece",
    three_letter_code: "GRC",
    iso_numeric: 300,
  },
  {
    code: "GL",
    name: "Greenland",
    three_letter_code: "GRL",
    iso_numeric: 304,
  },
  {
    code: "GD",
    name: "Grenada",
    three_letter_code: "GRD",
    iso_numeric: 308,
  },
  {
    code: "GP",
    name: "Guadeloupe",
    three_letter_code: "GLP",
    iso_numeric: 312,
  },
  {
    code: "GU",
    name: "Guam",
    three_letter_code: "GUM",
    iso_numeric: 316,
  },
  {
    code: "GT",
    name: "Guatemala",
    three_letter_code: "GTM",
    iso_numeric: 320,
  },
  {
    code: "GG",
    name: "Guernsey, Channel Islands",
    three_letter_code: "GSY",
    iso_numeric: 831,
  },
  {
    code: "GN",
    name: "Guinea",
    three_letter_code: "GIN",
    iso_numeric: 324,
  },
  {
    code: "GW",
    name: "Guinea-Bissau",
    three_letter_code: "GNB",
    iso_numeric: 624,
  },
  {
    code: "GY",
    name: "Guyana",
    three_letter_code: "GUY",
    iso_numeric: 328,
  },
  {
    code: "HT",
    name: "Haiti",
    three_letter_code: "HTI",
    iso_numeric: 332,
  },
  {
    code: "HN",
    name: "Honduras",
    three_letter_code: "HND",
    iso_numeric: 340,
  },
  {
    code: "HK",
    name: "Hong Kong",
    three_letter_code: "HKG",
    iso_numeric: 344,
  },
  {
    code: "HU",
    name: "Hungary",
    three_letter_code: "HUN",
    iso_numeric: 348,
  },
  {
    code: "IS",
    name: "Iceland",
    three_letter_code: "ISL",
    iso_numeric: 352,
  },
  {
    code: "IN",
    name: "India",
    three_letter_code: "IND",
    iso_numeric: 356,
  },
  {
    code: "ID",
    name: "Indonesia",
    three_letter_code: "IDN",
    iso_numeric: 360,
  },
  {
    code: "IE",
    name: "Ireland",
    three_letter_code: "IRL",
    iso_numeric: 372,
  },
  {
    code: "IM",
    name: "Isle of Man",
    three_letter_code: "IMN",
    iso_numeric: 833,
  },
  {
    code: "IL",
    name: "Israel",
    three_letter_code: "ISR",
    iso_numeric: 376,
  },
  {
    code: "IT",
    name: "Italy",
    three_letter_code: "ITA",
    iso_numeric: 380,
  },
  {
    code: "JM",
    name: "Jamaica",
    three_letter_code: "JAM",
    iso_numeric: 388,
  },
  {
    code: "SJ",
    name: "Jan Mayen",
    three_letter_code: "SJM",
    iso_numeric: 744,
  },
  {
    code: "JP",
    name: "Japan",
    three_letter_code: "JPN",
    iso_numeric: 392,
  },
  {
    code: "JE",
    name: "Jersey",
    three_letter_code: "JEY",
    iso_numeric: 832,
  },
  {
    code: "JO",
    name: "Jordan",
    three_letter_code: "JOR",
    iso_numeric: 400,
  },
  {
    code: "KZ",
    name: "Kazakhstan",
    three_letter_code: "KAZ",
    iso_numeric: 398,
  },
  {
    code: "KE",
    name: "Kenya",
    three_letter_code: "KEN",
    iso_numeric: 404,
  },
  {
    code: "KI",
    name: "Kiribati",
    three_letter_code: "KIR",
    iso_numeric: 296,
  },
  {
    code: "XK",
    name: "Kosovo",
    three_letter_code: "XKX",
    iso_numeric: 0,
  },
  {
    code: "KW",
    name: "Kuwait",
    three_letter_code: "KWT",
    iso_numeric: 414,
  },
  {
    code: "KG",
    name: "Kyrgyzstan",
    three_letter_code: "KGZ",
    iso_numeric: 417,
  },
  {
    code: "LA",
    name: "Lao People's Democratic Republic",
    three_letter_code: "LAO",
    iso_numeric: 418,
  },
  {
    code: "LV",
    name: "Latvia",
    three_letter_code: "LVA",
    iso_numeric: 428,
  },
  {
    code: "LB",
    name: "Lebanon",
    three_letter_code: "LBN",
    iso_numeric: 422,
  },
  {
    code: "LR",
    name: "Liberia",
    three_letter_code: "LBR",
    iso_numeric: 430,
  },
  {
    code: "LI",
    name: "Liechtenstein",
    three_letter_code: "LIE",
    iso_numeric: 438,
  },
  {
    code: "LT",
    name: "Lithuania",
    three_letter_code: "LTU",
    iso_numeric: 440,
  },
  {
    code: "LU",
    name: "Luxembourg",
    three_letter_code: "LUX",
    iso_numeric: 442,
  },
  {
    code: "MO",
    name: "Macao",
    three_letter_code: "MAC",
    iso_numeric: 446,
  },
  {
    code: "MK",
    name: "Macedonia",
    three_letter_code: "MKD",
    iso_numeric: 807,
  },
  {
    code: "MG",
    name: "Madagascar",
    three_letter_code: "MDG",
    iso_numeric: 450,
  },
  {
    code: "MW",
    name: "Malawi",
    three_letter_code: "MWI",
    iso_numeric: 454,
  },
  {
    code: "MY",
    name: "Malaysia",
    three_letter_code: "MYS",
    iso_numeric: 458,
  },
  {
    code: "MV",
    name: "Maldives",
    three_letter_code: "MDV",
    iso_numeric: 462,
  },
  {
    code: "ML",
    name: "Mali",
    three_letter_code: "MLI",
    iso_numeric: 466,
  },
  {
    code: "MT",
    name: "Malta",
    three_letter_code: "MLT",
    iso_numeric: 470,
  },
  {
    code: "MH",
    name: "Marshall Islands",
    three_letter_code: "MHL",
    iso_numeric: 584,
  },
  {
    code: "MQ",
    name: "Martinique",
    three_letter_code: "MTQ",
    iso_numeric: 474,
  },
  {
    code: "MR",
    name: "Mauritania",
    three_letter_code: "MRT",
    iso_numeric: 478,
  },
  {
    code: "MU",
    name: "Mauritius",
    three_letter_code: "MUS",
    iso_numeric: 480,
  },
  {
    code: "YT",
    name: "Mayotte",
    three_letter_code: "MYT",
    iso_numeric: 175,
  },
  {
    code: "MX",
    name: "Mexico",
    three_letter_code: "MEX",
    iso_numeric: 484,
  },
  {
    code: "FM",
    name: "Micronesia",
    three_letter_code: "FSM",
    iso_numeric: 583,
  },
  {
    code: "MD",
    name: "Moldova",
    three_letter_code: "MDA",
    iso_numeric: 498,
  },
  {
    code: "MC",
    name: "Monaco",
    three_letter_code: "MCO",
    iso_numeric: 492,
  },
  {
    code: "MN",
    name: "Mongolia",
    three_letter_code: "MNG",
    iso_numeric: 496,
  },
  {
    code: "ME",
    name: "Montenegro",
    three_letter_code: "MNE",
    iso_numeric: 499,
  },
  {
    code: "MS",
    name: "Montserrat",
    three_letter_code: "MSR",
    iso_numeric: 500,
  },
  {
    code: "MA",
    name: "Morocco",
    three_letter_code: "MAR",
    iso_numeric: 504,
  },
  {
    code: "MZ",
    name: "Mozambique",
    three_letter_code: "MOZ",
    iso_numeric: 508,
  },
  {
    code: "NA",
    name: "Namibia",
    three_letter_code: "NAM",
    iso_numeric: 516,
  },
  {
    code: "NR",
    name: "Nauru",
    three_letter_code: "NRU",
    iso_numeric: 520,
  },
  {
    code: "NP",
    name: "Nepal",
    three_letter_code: "NPL",
    iso_numeric: 524,
  },
  {
    code: "NL",
    name: "Netherlands",
    three_letter_code: "NLD",
    iso_numeric: 528,
  },
  {
    code: "AN",
    name: "Netherlands Antilles",
    three_letter_code: "ANT",
    iso_numeric: 530,
  },
  {
    code: "NC",
    name: "New Caledonia",
    three_letter_code: "NCL",
    iso_numeric: 540,
  },
  {
    code: "NZ",
    name: "New Zealand",
    three_letter_code: "NZL",
    iso_numeric: 554,
  },
  {
    code: "NI",
    name: "Nicaragua",
    three_letter_code: "NIC",
    iso_numeric: 558,
  },
  {
    code: "NE",
    name: "Niger",
    three_letter_code: "NER",
    iso_numeric: 562,
  },
  {
    code: "NG",
    name: "Nigeria",
    three_letter_code: "NGA",
    iso_numeric: 566,
  },
  {
    code: "NU",
    name: "Niue",
    three_letter_code: "NIU",
    iso_numeric: 570,
  },
  {
    code: "MP",
    name: "Northern Mariana Islands",
    three_letter_code: "MNP",
    iso_numeric: 580,
  },
  {
    code: "NO",
    name: "Norway",
    three_letter_code: "NOR",
    iso_numeric: 578,
  },
  {
    code: "OM",
    name: "Oman",
    three_letter_code: "OMN",
    iso_numeric: 512,
  },
  {
    code: "PK",
    name: "Pakistan",
    three_letter_code: "PAK",
    iso_numeric: 586,
  },
  {
    code: "PW",
    name: "Palau",
    three_letter_code: "PLW",
    iso_numeric: 585,
  },
  {
    code: "PS",
    name: "Palestine",
    three_letter_code: "PSE",
    iso_numeric: 275,
  },
  {
    code: "PA",
    name: "Panama",
    three_letter_code: "PAN",
    iso_numeric: 591,
  },
  {
    code: "PY",
    name: "Paraguay",
    three_letter_code: "PRY",
    iso_numeric: 600,
  },
  {
    code: "PE",
    name: "Peru",
    three_letter_code: "PER",
    iso_numeric: 604,
  },
  {
    code: "PH",
    name: "Philippines",
    three_letter_code: "PHL",
    iso_numeric: 608,
  },
  {
    code: "PN",
    name: "Pitcairn Islands",
    three_letter_code: "PCN",
    iso_numeric: 612,
  },
  {
    code: "PL",
    name: "Poland",
    three_letter_code: "POL",
    iso_numeric: 616,
  },
  {
    code: "PT",
    name: "Portugal",
    three_letter_code: "PRT",
    iso_numeric: 620,
  },
  {
    code: "PR",
    name: "Puerto Rico",
    three_letter_code: "PRI",
    iso_numeric: 630,
  },
  {
    code: "QA",
    name: "Qatar",
    three_letter_code: "QAT",
    iso_numeric: 634,
  },
  {
    code: "RE",
    name: "Reunion Island",
    three_letter_code: "REU",
    iso_numeric: 638,
  },
  {
    code: "RO",
    name: "Romania",
    three_letter_code: "ROU",
    iso_numeric: 642,
  },
  {
    code: "RU",
    name: "Russia",
    three_letter_code: "RUS",
    iso_numeric: 643,
  },
  {
    code: "RW",
    name: "Rwanda",
    three_letter_code: "RWA",
    iso_numeric: 646,
  },
  {
    code: "BL",
    name: "Saint Barthélemy",
    three_letter_code: "BLM",
    iso_numeric: 652,
  },
  {
    code: "SH",
    name: "Saint Helena",
    three_letter_code: "SHN",
    iso_numeric: 654,
  },
  {
    code: "KN",
    name: "Saint Kitts and Nevis",
    three_letter_code: "KNA",
    iso_numeric: 659,
  },
  {
    code: "LC",
    name: "Saint Lucia",
    three_letter_code: "LCA",
    iso_numeric: 662,
  },
  {
    code: "MF",
    name: "Saint Martin",
    three_letter_code: "MAF",
    iso_numeric: 663,
  },
  {
    code: "PM",
    name: "Saint Pierre and Miquelon",
    three_letter_code: "SPM",
    iso_numeric: 666,
  },
  {
    code: "VC",
    name: "Saint Vincent and The Grenadines",
    three_letter_code: "VCT",
    iso_numeric: 670,
  },
  {
    code: "WS",
    name: "Samoa",
    three_letter_code: "WSM",
    iso_numeric: 882,
  },
  {
    code: "SM",
    name: "San Marino",
    three_letter_code: "SMR",
    iso_numeric: 674,
  },
  {
    code: "ST",
    name: "Sao Tome and Principe",
    three_letter_code: "STP",
    iso_numeric: 678,
  },
  {
    code: "SA",
    name: "Saudi Arabia",
    three_letter_code: "SAU",
    iso_numeric: 682,
  },
  {
    code: "SN",
    name: "Senegal",
    three_letter_code: "SEN",
    iso_numeric: 686,
  },
  {
    code: "RS",
    name: "Serbia",
    three_letter_code: "SRB",
    iso_numeric: 688,
  },
  {
    code: "SC",
    name: "Seychelles",
    three_letter_code: "SYC",
    iso_numeric: 690,
  },
  {
    code: "SL",
    name: "Sierra Leone",
    three_letter_code: "SLE",
    iso_numeric: 694,
  },
  {
    code: "SG",
    name: "Singapore",
    three_letter_code: "SGP",
    iso_numeric: 702,
  },
  {
    code: "SX",
    name: "Sint Maarten",
    three_letter_code: "SXM",
    iso_numeric: 534,
  },
  {
    code: "SK",
    name: "Slovakia ",
    three_letter_code: "SVK",
    iso_numeric: 703,
  },
  {
    code: "SI",
    name: "Slovenia",
    three_letter_code: "SVN",
    iso_numeric: 705,
  },
  {
    code: "SB",
    name: "Solomon Islands",
    three_letter_code: "SLB",
    iso_numeric: 90,
  },
  {
    code: "ZA",
    name: "South Africa",
    three_letter_code: "ZAF",
    iso_numeric: 710,
  },
  {
    code: "KR",
    name: "South Korea",
    three_letter_code: "KOR",
    iso_numeric: 410,
  },
  {
    code: "ES",
    name: "Spain",
    three_letter_code: "ESP",
    iso_numeric: 724,
  },
  {
    code: "LK",
    name: "Sri Lanka",
    three_letter_code: "LKA",
    iso_numeric: 144,
  },
  {
    code: "SR",
    name: "Suriname",
    three_letter_code: "SUR",
    iso_numeric: 740,
  },
  {
    code: "SZ",
    name: "Swaziland",
    three_letter_code: "SWZ",
    iso_numeric: 748,
  },
  {
    code: "SE",
    name: "Sweden",
    three_letter_code: "SWE",
    iso_numeric: 752,
  },
  {
    code: "CH",
    name: "Switzerland",
    three_letter_code: "CHE",
    iso_numeric: 756,
  },
  {
    code: "TW",
    name: "Taiwan",
    three_letter_code: "TWN",
    iso_numeric: 158,
  },
  {
    code: "TJ",
    name: "Tajikistan",
    three_letter_code: "TJK",
    iso_numeric: 762,
  },
  {
    code: "TZ",
    name: "Tanzania",
    three_letter_code: "TZA",
    iso_numeric: 834,
  },
  {
    code: "TH",
    name: "Thailand",
    three_letter_code: "THA",
    iso_numeric: 764,
  },
  {
    code: "TL",
    name: "Timor-Leste",
    three_letter_code: "TLS",
    iso_numeric: 626,
  },
  {
    code: "TG",
    name: "Togo",
    three_letter_code: "TGO",
    iso_numeric: 768,
  },
  {
    code: "TK",
    name: "Tokelau",
    three_letter_code: "TKL",
    iso_numeric: 772,
  },
  {
    code: "TO",
    name: "Tonga",
    three_letter_code: "TON",
    iso_numeric: 776,
  },
  {
    code: "TT",
    name: "Trinidad and Tobago",
    three_letter_code: "TTO",
    iso_numeric: 780,
  },
  {
    code: "TN",
    name: "Tunisia",
    three_letter_code: "TUN",
    iso_numeric: 788,
  },
  {
    code: "TR",
    name: "Turkey",
    three_letter_code: "TUR",
    iso_numeric: 792,
  },
  {
    code: "TM",
    name: "Turkmenistan",
    three_letter_code: "TKM",
    iso_numeric: 795,
  },
  {
    code: "TC",
    name: "Turks and Caicos Islands",
    three_letter_code: "TCA",
    iso_numeric: 796,
  },
  {
    code: "TV",
    name: "Tuvalu",
    three_letter_code: "TUV",
    iso_numeric: 798,
  },
  {
    code: "VI",
    name: "U.S. Virgin Islands",
    three_letter_code: "VIR",
    iso_numeric: 850,
  },
  {
    code: "UG",
    name: "Uganda",
    three_letter_code: "UGA",
    iso_numeric: 800,
  },
  {
    code: "UA",
    name: "Ukraine",
    three_letter_code: "UKR",
    iso_numeric: 804,
  },
  {
    code: "AE",
    name: "United Arab Emirates",
    three_letter_code: "ARE",
    iso_numeric: 784,
  },
  {
    code: "GB",
    name: "United Kingdom",
    three_letter_code: "GBR",
    iso_numeric: 826,
  },
  {
    code: "US",
    name: "United States",
    three_letter_code: "USA",
    iso_numeric: 840,
  },
  {
    code: "UM",
    name: "United States Minor Outlying Islands",
    three_letter_code: "UMI",
    iso_numeric: 581,
  },
  {
    code: "UY",
    name: "Uruguay",
    three_letter_code: "URY",
    iso_numeric: 858,
  },
  {
    code: "UZ",
    name: "Uzbekistan",
    three_letter_code: "UZB",
    iso_numeric: 860,
  },
  {
    code: "VU",
    name: "Vanuatu",
    three_letter_code: "VUT",
    iso_numeric: 548,
  },
  {
    code: "VA",
    name: "Vatican City",
    three_letter_code: "VAT",
    iso_numeric: 336,
  },
  {
    code: "VE",
    name: "Venezuela",
    three_letter_code: "VEN",
    iso_numeric: 862,
  },
  {
    code: "VN",
    name: "Viet Nam",
    three_letter_code: "VNM",
    iso_numeric: 704,
  },
  {
    code: "WF",
    name: "Wallis and Futuna Islands",
    three_letter_code: "WLF",
    iso_numeric: 876,
  },
  {
    code: "EH",
    name: "Western Sahara",
    three_letter_code: "ESH",
    iso_numeric: 732,
  },
  {
    code: "ZM",
    name: "Zambia",
    three_letter_code: "ZMB",
    iso_numeric: 894,
  },
];

export const Countries_convert_3to2 = Countries_List.reduce((acc, country) => {
  let { code, three_letter_code } = country;
  return { ...acc, [three_letter_code]: code };
}, {});

export const Countries_convert_2to3 = Countries_List.reduce((acc, country) => {
  let { code, three_letter_code } = country;
  return { ...acc, [code]: three_letter_code };
}, {});
